import * as React from 'react';
import { RequestApiError } from 'loopback-react-request';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { LogoCentered } from '../../Images';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Activation.messages';

import './ActivationFailed.scss';

export interface ActivationFailedProps {
  error: RequestApiError;
}

const InvalidToken = () => {
  return (
    <>
      <p className="text-danger">
        <FormattedMessage {...MESSAGES.activaionInvalidToken} />
      </p>
      <Link to="/" className="btn btn-secondary d-block w-100 mt-5">Login</Link>
      <Button className="btn btn-secondary d-block w-100 mt-3">
        <FormattedMessage {...MESSAGES.activaionInvalidTokenButton} />
      </Button>
    </>
  );
};

const UserNotFound = () => {
  return (
    <>
      <p className="text-danger">
        <FormattedMessage {...MESSAGES.activaionUserNotFound} />
      </p>
      <Link className="btn btn-secondary d-block w-100 mt-5" to="/register">
        <FormattedMessage {...MESSAGES.activaionUserNotFound} />
      </Link>
    </>
  );
};

export class ActivationFailed extends React.Component<ActivationFailedProps> {
  public render() {
    const { error } = this.props;
    return (
      <div className="partial-activation-failed d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="col-12">
            <LogoCentered />
            <p>
              <FormattedMessage {...MESSAGES.activaionInvalid} />
            </p>
            <p>
              {error && error.code && this.resolveErrorCodes()}
            </p>
          </div>
        </div>
      </div>
    );
  }

  private resolveErrorCodes(): React.ReactNode | null {
    const { error } = this.props;
    switch (error.code) {
      case 'USER_NOT_FOUND':
        return <UserNotFound />;
      case 'INVALID_TOKEN':
        return <InvalidToken />;
      default:
        return <Redirect to="/" />;
    }
  }
}
